const ClosingSignature = () => {
  return (
    <section className="py-24 sm:py-32 px-6 bg-[#E8D2B5]">
      <div className="max-w-xl mx-auto text-center">
        
        {/* Closing poem */}
        <div className="space-y-4 text-[#3F2A24] font-serif text-base sm:text-lg leading-[2.4]">
          <p>Certains lieux</p>
          <p>ne sont pas des destinations.</p>
          <p className="italic pt-2">Ce sont des passages.</p>
          
          <div className="w-8 h-[1px] bg-[#C5A059]/30 mx-auto my-6" />
          
          <p>Des endroits où l'on arrive,</p>
          <p>où l'on ralentit,</p>
          <p className="pt-2">et où l'on découvre</p>
          <p className="italic">que quelque chose en nous</p>
          <p className="italic">est prêt à changer.</p>
        </div>
      </div>
    </section>
  );
};

export default ClosingSignature;
